<template>
  <g>
    <path
      d="M18 8.00018C15.79 8.00018 14 9.79018 14 12.0002C14 14.2102 15.79 16.0002 18 16.0002C20.21 16.0002 22 14.2102 22 12.0002C22 9.79018 20.21 8.00018 18 8.00018ZM15.5 12.0002C15.5 10.6202 16.62 9.50018 18 9.50018C18.42 9.50018 18.8 9.61018 19.15 9.79018L15.79 13.1502C15.61 12.8002 15.5 12.4202 15.5 12.0002ZM18 14.5002C17.58 14.5002 17.2 14.3902 16.85 14.2102L20.21 10.8502C20.39 11.2002 20.5 11.5802 20.5 12.0002C20.5 13.3802 19.38 14.5002 18 14.5002Z"
    />
    <path
      d="M17 18.0002H7V6.00018H17V7.00018H19V6.00018V5.00018V3.00018C19 1.90018 18.1 1.00018 17 1.00018H7C5.9 1.00018 5 1.90018 5 3.00018V21.0002C5 22.1002 5.9 23.0002 7 23.0002H17C18.1 23.0002 19 22.1002 19 21.0002V19.0002V18.0002V17.0002H17V18.0002Z"
    />
  </g>
</template>
